import AbstractConnector from '../abstract-connector';
import { EnrollmentResponse, RequestBody, ResponseData } from '../connector';
import {
	ServiceNames,
	ServiceStatus,
} from '../../../constants/service.constants';

export default class MockConnector extends AbstractConnector {
	configuration: EnrollmentResponse;
	constructor(configuration: EnrollmentResponse) {
		super();
		this.configuration = configuration;
	}

	protected async prepareRequest(input: RequestBody) {
		console.log('Preparing request', input);
	}

	protected async sendRequest(): Promise<object> {
		console.log('Sending request');
		const SLEEP_TIME_MILLI_SECS = 2000;
		await this.sleep(SLEEP_TIME_MILLI_SECS);
		return {};
	}

	protected checkResponse() {
		console.log('Checking response');
		return true;
	}

	protected parseResponse(): ResponseData[] {
		console.log('Parsing response');
		let enrollmentData: ResponseData[] | undefined = [];
		enrollmentData = this.request?.serviceEnrollments.map((enrollment) => {
			console.log('Parsing', enrollment.name);
			let responseData: ResponseData = {
				patientId: 'mockPatientId',
				service: enrollment.name,
				state: ServiceStatus.enrolled,
			};
			switch (enrollment.name) {
				case ServiceNames.copay:
				case ServiceNames.fto:
					responseData = {
						...responseData,
						card: this.configuration.data.find(
								item => item.service === enrollment.name
							)?.card,
					};
					break;
				case ServiceNames.adherence:
					break;
			}
			return responseData;
		});
		return enrollmentData || [];
	}

	protected wrapRequest() {
		console.log('Wrapping request');
	}

	// Mock helper methods

	private sleep(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}
}
